import { EntityType, getEntityName } from '@ls/entity-service';
import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectEntities } from 'state/data/selectors';
import { setSelectedAccountEntityId, setSelectedBenchmarkEntityId } from 'state/selections/actions';

export const useEntitySelectorOptions = () => {
  const entities = useSelector(selectEntities);
  return useMemo(() => {
    return entities
      .map(entity => ({
        ...entity,
        label: getEntityName(entity),
      }))
      .sort((e1, e2) => {
        if (e1.type === EntityType.BMARK && e2.type === EntityType.BMARK) {
          if (e1.label < e2.label) return -1;
          if (e1.label > e2.label) return 1;
        }
        if (e1.type === EntityType.BMARK) return 1;
        if (e2.type === EntityType.BMARK) return -1;
        if (e1.label < e2.label) return -1;
        if (e1.label > e2.label) return 1;
        return 0;
      });
  }, [entities]);
};

export const useGetDefaultBenchmarkEntity = () => {
  const entities = useSelector(selectEntities);
  return useCallback((entityId) => {
    const selectedEntity = entities?.find(entity => entity.entityId === entityId);
    if (selectedEntity?.benchmarkId) {
      return entities.find(entity => entity.entityId === selectedEntity.benchmarkId);
    }
  }, [entities]);
};


export const useOnChangeAccount = () => {
  const dispatch = useDispatch();
  const getDefaultBenchmarkEntity = useGetDefaultBenchmarkEntity();

  return useCallback((entityId) => {
    dispatch(setSelectedAccountEntityId(entityId));
    const defaultBenchmarkEntity = getDefaultBenchmarkEntity(entityId);
    if (defaultBenchmarkEntity) {
      dispatch(setSelectedBenchmarkEntityId(defaultBenchmarkEntity.entityId));
    } else {
      dispatch(setSelectedBenchmarkEntityId(null));
    }
  }, [getDefaultBenchmarkEntity, dispatch]);
}